// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-meeting-nav-btn button{min-width:140px}.v-action-icon{cursor:pointer}.v-dates-block{background-color:rgba(35,53,83,.04)}.create-meeting-content.invalid,.invalid .multiselect__tags{border:1px solid #dc3545!important}@media(max-width:992px){.v-delete-date-icon{position:absolute;right:25px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
